import { render } from "./PreviewItem.vue?vue&type=template&id=46a554ca&scoped=true"
import script from "./PreviewItem.vue?vue&type=script&lang=js"
export * from "./PreviewItem.vue?vue&type=script&lang=js"

import "./PreviewItem.vue?vue&type=style&index=0&id=46a554ca&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a554ca"]])

export default __exports__